const getSortQuery = (columns, sortedColumn) => {
  const { index, order } = sortedColumn;
  const column = columns[index];
  if (column) {
    if (order === 'DESC') {
      return `-${column.sortBy ? column.sortBy : column.key}`;
    }
    return column.sortBy ? column.sortBy : column.key;
  }
  return '';
};

export default getSortQuery;
